import React, { Children, forwardRef, useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { isInternal } from "../../helpers";
import useProductsSelected from "../../hooks/useProductsSelected";

const AddOnSection = forwardRef(
  (
    {
      children,
      title,
      show_skus = [],
      addon_skus = [],
      hideInternal,
      className,
      onShow,
    },
    ref
  ) => {
    const showRef = useRef(show_skus);
    const addonRef = useRef(addon_skus);
    const selected = useProductsSelected(showRef.current);
    const show = selected || (isInternal() && !hideInternal);
    const first = useRef(false);
    const { unregister } = useFormContext();

    useEffect(() => {
      addonRef.current = addon_skus;
    }, [addon_skus]);

    useEffect(() => {
      if (!show && first.current) {
        unregister(addonRef.current);
      } else {
        first.current = true;
      }
    }, [show, unregister]);

    useEffect(() => {
      if (show && onShow) onShow();
    }, [show, onShow]);

    if (!show) return null;
    const hasChildren = !!Children.count(children);

    return (
      <div className={className} ref={ref}>
        {title && hasChildren && <h2 className="mb-4">{title}</h2>}
        {children}
      </div>
    );
  }
);

export default AddOnSection;
